import { Modal, notification } from 'antd';
import React from 'react';

import { deletePaymentInstrument as deleteApi } from 'src/apis/companyPaymentInstrument';
import { config } from 'src/apis/api';

const { confirm } = Modal;

const deletePaymentInstrument = (companyID: number, companyName: string) => {
  confirm({
    title: 'Clear Stored Payment Method',
    content: <>
      <p>Are you sure you want to clear <strong>{companyName} - {companyID}'s</strong> stored payment method?</p>
      <p>We will be unable to charge the company until they enter a new one.</p>
    </>,
    okType: 'danger',
    onOk: () => {
      deleteApi(config.authToken || '', companyID)
        .then(() => notification.success({ message: 'Successfully cleared payment method.' }))
        .catch(() => notification.error({ message: 'Failed to clear stored payment method. Contact #team-goblin.' }));
    },
  });
};

export default deletePaymentInstrument;
